export default {"src":"/_next/static/media/orgSelectedIcon.06e5b2bb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};